var map = {
	"./affiliate/alleya-khan.png": "9667",
	"./affiliate/cameron-oneill.png": "9d26",
	"./affiliate/dane-armstrong.png": "1bda",
	"./affiliate/dane-vanden-heuvel.png": "4424",
	"./affiliate/daniel-roberts.png": "8209",
	"./affiliate/fraser-maclachlan.png": "9880",
	"./affiliate/fred-jean-bart.png": "012a",
	"./affiliate/hulland-bui.png": "961b",
	"./affiliate/lisa-hill.png": "b00f",
	"./affiliate/meg-david.png": "157d",
	"./affiliate/min-chang.png": "38f6",
	"./affiliate/mina-yoon.png": "891a",
	"./affiliate/samir-azizi.png": "3c935",
	"./affiliate/senth-sivakumaran.png": "27c7",
	"./affiliate/shelley-gu.png": "1b28",
	"./merchant/aaron-paul.png": "6ba8",
	"./merchant/conor-kieran.png": "9ce8",
	"./merchant/cooper-voskuil.png": "2f06",
	"./merchant/giancarlo-rios.png": "8d8a",
	"./merchant/greg-fitzgerald.png": "2df3",
	"./merchant/heather-kelly.png": "da89",
	"./merchant/sandra-woo.png": "541f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2e5f";